module.exports = __webpack_public_path__ + "img/typewriters.e8226eef.gif";